import { createFileRoute } from "@tanstack/react-router";
import { AuditLogPage } from "@/features/admin/audit-log-page";
import { ensureAdminAccess } from "@/lib/route-guards";

export const Route = createFileRoute("/_auth/konfiguracja/audit-log")({
	beforeLoad: async () => {
		await ensureAdminAccess();
	},
	component: AuditLogPage,
});
